import API from "./API";

const safeString = (value) => (value === null || value === undefined ? "" : String(value));
const PDF_OBJECT_URL_REVOKE_MS = 60 * 1000;

const readBlobErrorMessage = async (error) => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      if (!text) return "";
      try {
        const parsed = JSON.parse(text);
        return safeString(parsed?.message || parsed?.error?.message || parsed?.error || text);
      } catch {
        return safeString(text);
      }
    } catch {
      return "";
    }
  }
  return safeString(error?.response?.data?.message || error?.response?.data?.error || error?.message);
};

const createObjectUrl = (blob) => {
  const url = URL.createObjectURL(blob);
  window.setTimeout(() => URL.revokeObjectURL(url), PDF_OBJECT_URL_REVOKE_MS);
  return url;
};

export const getOrderInvoicePdfBlob = async (orderId, mode = "view") => {
  const normalizedId = safeString(orderId).trim();
  if (!normalizedId) throw new Error("Order ID is required to load invoice.");

  try {
    const response = await API.get(
      `/order/admin/${encodeURIComponent(normalizedId)}/pdf${mode === "download" ? "/download" : ""}`,
      {
        responseType: "blob",
        headers: { Accept: "application/pdf" },
      }
    );
    return response.data;
  } catch (error) {
    const message = await readBlobErrorMessage(error);
    throw new Error(message || "Could not load invoice.");
  }
};

export const openOrderInvoice = async (orderId) => {
  const popup = window.open("", "_blank");
  try {
    const blob = await getOrderInvoicePdfBlob(orderId, "view");
    const url = createObjectUrl(blob);
    if (popup) {
      popup.location.href = url;
    } else {
      window.location.href = url;
    }
  } catch (error) {
    if (popup) popup.close();
    throw error;
  }
};

export const downloadOrderInvoice = async (orderId, fileName = "") => {
  const blob = await getOrderInvoicePdfBlob(orderId, "download");
  const url = createObjectUrl(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};
